import React, { useState, useEffect, useRef } from "react";
import { auth } from "./firebase";
import { getFirestore, doc, limit, getDoc,  getDocs, updateDoc, collection, query, where, onSnapshot, setDoc, serverTimestamp, orderBy, addDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
// import { io } from "socket.io-client";
import { getStorage, uploadBytesResumable, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Card, ListGroup, Spinner, Stack, Modal, Button, Form, Image, Container, Row, Col, Alert, ToggleButton, ToggleButtonGroup, ButtonGroup } from 'react-bootstrap';
// import { FaHourglass, FaClock, FaUserClock, FaArrowLeft, FaDollarSign, FaHourglassEnd, FaMoneyBill, FaMoneyBillAlt } from "react-icons/fa";

const db = getFirestore();
// const socket = io("https://priests.africa"); // Use the same socket server

const ConsultantDashboard = () => {
  const [consultant, setConsultant] = useState(null);
  const [pendingChatRequests, setPendingChatRequests] = useState([]);
  // For simplicity, we use activeChat state to show the chat UI once accepted.
  const [activeChats, setActiveChats] = useState([]);
  const [activeChat, setActiveChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [recording, setRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const navigate = useNavigate();

  // close chat
  const [showEndChatModal, setShowEndChatModal] = useState(false);
  const [showChatEndedModal, setShowChatEndedModal] = useState(false);

  // New state variables for editing rate
  // const [editingRate, setEditingRate] = useState(false);
  // const [newRate, setNewRate] = useState(0);
  const [editingRate, setEditingRate] = useState(false);
  // const [rateType, setRateType] = useState(consultant?.consultationCharge > 0 ? "consultation" : "perMinute");
    const [rateType, setRateType] = useState("consultation");
  const [newRate, setNewRate] = useState(consultant?.ratePerMinute || 0);
  const [newConsultationCharge, setNewConsultationCharge] = useState(consultant?.consultationCharge || 0);
  const [radioValue, setRadioValue] = useState('1');
  const [editRate, setEditRate] = useState(false);

  // For tracking consultant activity (for auto offline)
  const [lastActivity, setLastActivity] = useState(Date.now());

  // New state for editing consultant name
  const [editingUsername, setEditingUsername] = useState(false);
  const [newUsername, setNewUsername] = useState("");
  const [userData, setUserData] = useState(null);
  const [showModal, setShowModal] = useState(false);


  // new profile photo
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState(consultant?.photoURL || "/default-avatar.png");

  // chat timer
  const [seconds, setSeconds] = useState(0);

  // editing intro
  const [editingIntro, setEditingIntro] = useState(false);
  const [newIntro, setNewIntro] = useState(consultant?.intro || ""); 
  const [selectedFocus, setSelectedFocus] = useState(consultant?.tags || []);

  const [loadingauth, setLoadingauth] = useState(true); // Track authentication status

  // withdrawal
  const [showATM, setShowATM] = useState(false);
  const [atmAmount, setAtmAmount] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [error, setError] = useState("");

  const handleWithdrawClick = () => {
    setShowATM(true);
    setAtmAmount("");
    setError("");
  };

  const closeATM = () => {
    setAtmAmount("");
    setError("");
    setShowATM(false)
  };


  // console.log('consultant dashboard')
  
  // Fetch active chats for the consultant
    useEffect(() => {
      if (consultant) {
        const q = query(
          collection(db, "chatRooms"),
          where("consultantId", "==", consultant.id)
        );

        const unsubscribe = onSnapshot(q, async (querySnapshot) => {
          const chatPromises = querySnapshot.docs.map(async (chatDoc) => {
            const chatData = { id: chatDoc.id, ...chatDoc.data() };

            // Get the last message from the messages subcollection
            const messagesQuery = query(
              collection(db, "chatRooms", chatDoc.id, "messages"),
              orderBy("createdAt", "desc"),
              limit(1) // Only get the latest message
            );

            const messageSnapshot = await getDocs(messagesQuery);
            if (!messageSnapshot.empty) {
              const lastMessage = messageSnapshot.docs[0].data();
              chatData.lastMessage = lastMessage;

              
            }
            return chatData;
          })

          const chatsWithMessages = await Promise.all(chatPromises);
          chatsWithMessages.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
          setActiveChats(chatsWithMessages);
          // console.log(chatsWithMessages[0])
        });

        return () => unsubscribe();
      }
    }, [consultant]);


  useEffect(() => {
    const fetchUserData = async () => {
      if (auth.currentUser) {
        const userRef = doc(db, "priest_users", auth.currentUser.uid);
        const userSnap = await getDoc(userRef);
        // console.log('userSnap.data(): ', userSnap.data())
        
        if (userSnap.exists()) {
          setUserData(userSnap.data()); // Store user data
          // console.log('userData: ', userData)
        }
      }
    };
  
    fetchUserData();
  }, [auth.currentUser]);

  useEffect(() => {
    // console.log('AuthStateChanged')
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "priest_users", user.uid));
        if (userDoc.exists() && userDoc.data().role === "consultant") {
          setConsultant({ id: user.uid, ...userDoc.data() });
          // setConsultant(userDoc.data());
        } else {
          // alert("Access denied.");
          // auth.signOut();
          navigate("/");
        }
      }
    });
  }, [navigate]);
 

   // Listen for pending chat requests for this consultant
  //  useEffect(() => {
  //   if (consultant) {
  //     const q = query(
  //       collection(db, "chatRequests"),
  //       where("consultantId", "==", consultant.id),
  //       where("status", "==", "pending")
  //     );
  //     const unsubscribe = onSnapshot(q, (querySnapshot) => {
  //       const requests = [];
  //       querySnapshot.forEach((doc) => {
  //         requests.push({ id: doc.id, ...doc.data() });
  //       });
  //       setPendingChatRequests(requests);
  //     });
  //     return () => unsubscribe();
  //   }
  // }, [consultant]);

   // Listen for messages in the active chat room
  //  useEffect(() => {
  //   if (activeChat && activeChat.chatRoomId) {
  //     const messagesRef = collection(db, "chatRooms", activeChat.chatRoomId, "messages");
  //     const q = query(messagesRef, orderBy("createdAt", "asc"));
  //     const unsubscribe = onSnapshot(q, (snapshot) => {
  //       const msgs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  //       setMessages(msgs);
  //     });
  //     return () => unsubscribe();
  //   }
  // }, [activeChat]);

  // Listen for "ended" Status
  useEffect(() => {
    if (activeChat && activeChat.chatRoomId) {
      const chatRequestRef = doc(db, "chatRequests", activeChat.chatRoomId);
      // console.log('user sending ending req')
      const unsubscribe = onSnapshot(chatRequestRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
     
          if (data.status === "ended") {
            console.log('chat status2: ', data.status)
           
            // Show a modal to inform the consultant that the user ended the chat
            setShowChatEndedModal(true);
            // precaution:its causing errors when you end session from consultant and 
            // then request again so:
            setShowEndChatModal(false)
          }
        }
      });
  
      return () => unsubscribe();
    }
  }, [activeChat]);

  // ---------------------------
  // Activity Tracking for Auto Offline
  // ---------------------------
  useEffect(() => {
    const updateActivity = () => {
      setLastActivity(Date.now());
      console.log('consultant.mode: ', consultant.mode)
      // If consultant is not busy (i.e. no active chat) update mode to "online"
      if (consultant && !activeChat && consultant.mode !== "busy") {
        updateDoc(doc(db, "priest_users", consultant.id), { mode: "online" })
          .then(() => setConsultant((prev) => ({ ...prev, mode: "online" })))
          .catch((err) => console.error("Error updating mode to online:", err));
      }
    };

    window.addEventListener("mousemove", updateActivity);
    window.addEventListener("keydown", updateActivity);

    return () => {
      window.removeEventListener("mousemove", updateActivity);
      window.removeEventListener("keydown", updateActivity);
    };
  }, [consultant, activeChat]);


  // Check every minute if no activity for 5 minutes (300,000 ms) and no active chat, then set mode to "offline"
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastActivity > 300000 && consultant && !activeChat && consultant.mode === 'online') {
        updateDoc(doc(db, "priest_users", consultant.id), { mode: "offline" })
          .then(() => setConsultant((prev) => ({ ...prev, mode: "offline" })))
          .catch((err) => console.error("Error updating mode to offline:", err));
      }
    }, 60000);
    return () => clearInterval(interval);
  }, [lastActivity, consultant, activeChat]);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (editingIntro) {
      setNewIntro(consultant.intro || ""); // Pre-fill intro if available
      setSelectedFocus(consultant.tags || []); // Pre-select checkboxes
    }
  }, [editingIntro]); // Runs when consultant or edit modal opens


  useEffect(() => {
    fetchProfilePhoto();
  }, []);

   useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged((consultant) => {
        // setConsultant(consultant);
        setLoadingauth(false); // Mark loading as complete
      });
  
      return () => unsubscribe();
      // setLoadingauth(false);
    }, []);


  // Function to resume chat
// const resumeChat = (chat) => {
//   navigate("/activeconsultantchat", {
//     state: { 
//       consultant, 
//       userData: chat.user, 
//       activeChat: chat 
//     },
//   });
// };


    // Called when the consultant accepts a chat request.
  // This function updates the chat request's status to "accepted"
  // and creates a corresponding chat room document.
  // const acceptChatRequest = async (requestId, requestData) => {
  //   try {
  //     // Update the chat request document's status
  //     await updateDoc(doc(db, "chatRequests", requestId), { status: "accepted" });
  //     // Create a chat room document (using the same id as the chat request)
  //     await setDoc(doc(db, "chatRooms", requestId), {
  //       consultantName: consultant.name,
  //       consultantPhoto: consultant.photoURL,
  //       consultantId: consultant.id,
  //       user: requestData.user,
  //       createdAt: serverTimestamp()
  //     });

  //     // Set active chat with the chatRoomId = requestId
  //     // Set consultant mode to busy BEFORE navigating
  //     const updatedConsultant = { ...consultant, mode: "busy" };
  //     setConsultant(updatedConsultant);
  //     setActiveChat({ ...requestData, chatRoomId: requestId });
  //     await updateDoc(doc(db, "priest_users", consultant.id), { mode: "busy" });
  //      // 🔥 Navigate to ActiveUserChat and pass consultant data
  //      navigate("/activeconsultantchat", 
  //       { 
  //         state: { 
  //         consultant: updatedConsultant, 
  //         userData:requestData.user, 
  //         activeChat: { ...requestData, chatRoomId: requestId } 
  //       } 
  //       });

  //   } catch (error) {
  //     console.error("Error accepting chat request:", error);
  //   }
  // };

   // NEW: Called when the consultant rejects a chat request.
  // It updates the chat request's status to "rejected".
  // const rejectChatRequest = async (requestId) => {
  //   try {
  //     await updateDoc(doc(db, "chatRequests", requestId), { status: "rejected" });
  //   } catch (error) {
  //     console.error("Error rejecting chat request:", error);
  //   }
  // };

    const handleWithdraw = async () => {
      // console.log("consultant: ", consultant)
      const parsedAmount = parseFloat(atmAmount);

       // Check for empty fields
      if (!atmAmount || !accountName || !accountNumber || !bankName) {
        setError("Please fill in all the withdrawal details.");
        return;
      }

      if (isNaN(parsedAmount) || parsedAmount < 50) {
        setError("Minimum withdrawal amount is 50 USD.");
      } else {

        const amountAvailable = consultant.credits;
        if(parsedAmount <= amountAvailable){
              // Save withdrawal request
              await addDoc(collection(db, "withdrawal_requests"), {
              uid: auth.currentUser.uid,
              amount: parsedAmount,
              accountName: accountName,
              accountNumber:accountNumber,
              bankName: bankName,
              status: "pending",
              requestedAt: new Date(),
              });
    
              // Reset earnings
              await updateDoc(doc(db, "priest_users", auth.currentUser.uid), { credits: amountAvailable - parsedAmount});
          
              alert("Withdrawal request submitted!");

              // Proceed with actual withdrawal logic here
              // console.log("Withdrawing:", parsedAmount);
              setShowATM(false);
        }else{
          setError('The amount you wish to withdraw is unavailable')
        }
    
        
      }     
     
  };

  // Voice recording functions for consultant
  const storage = getStorage();
  
    // Allow the consultant to update their rate per minute in collection "priest_users"
    const updateRate = async () => {
      try {
        const updatedData = rateType === "perMinute" 
          ? { ratePerMinute: newRate, consultationCharge: 0 }
          : { consultationCharge: newConsultationCharge, ratePerMinute: 0 };
  
        await updateDoc(doc(db, "priest_users", consultant.id), updatedData);
        setConsultant((prev) => ({ ...prev, ...updatedData }));
        // setEditingRate(false);
        setEditRate(false)
      } catch (error) {
        console.error("Error updating rate:", error);
      }
    };

    const handleRateTypeChange = (type) => {
      console.log('type1: ', type)
      setRateType(type);
      if (type === "perMinute") {
        console.log('type2: ', type)

        setNewConsultationCharge(0);
      } else {
        console.log('type3: ', type)

        setNewRate(0);
      }
    };
  

    // Function to save updated username in 'priest_users' collection.
    const handleSaveUsername = async () => {
      try {
        await updateDoc(doc(db, "priest_users", consultant.id), { username: newUsername });
        // Update local state as well.
        setConsultant((prev) => ({ ...prev, username: newUsername }));
        setEditingUsername(false);
      } catch (error) {
        console.error("Error updating username:", error);
      }
    };


    // const changeRate = (event) => {
    //   const rate = event.target.value;
    //   setNewRate(rate)
    // }

   
  // Fetch user profile photo from Firestore
  const fetchProfilePhoto = async () => {
    try {
      if (!consultant?.id) return; // Early exit if consultant doesn't have an id

      const userDocRef = doc(db, "users", consultant.id);
      const docSnap = await getDoc(userDocRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.photoURL) {
          setImageUrl(data.photoURL);
        }
      }
    } catch (error) {
      console.error("Error fetching profile photo:", error);
    }
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const storageRef = ref(storage, `profile_photos/${consultant.id}`); // Store in Firebase Storage
    const uploadTask = uploadBytesResumable(storageRef, file);

    setUploading(true);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Progress tracking (optional)
      },
      (error) => {
        console.error("Upload error:", error);
        setUploading(false);
      },
      async () => {
        // Get URL of uploaded image
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        setProfilePhoto(downloadURL);
        setImageUrl(downloadURL);
        setUploading(false);

        // Update Firestore with new profile photo URL
        const userDocRef = doc(db, "priest_users", consultant.id);
        await updateDoc(userDocRef, { photoURL: downloadURL });
      }
    );
  };


  const handleSaveIntro = async () => {
    if (!consultant?.id) {
      console.error("Error: Consultant ID is missing.");
      return;
    }
  
    const consultantRef = doc(db, "priest_users", consultant.id);
  
    try {
      await updateDoc(consultantRef, {
        intro: newIntro,
        tags: selectedFocus, // Store multiple selected focus areas
      });
  
      // Update local state
      setEditingIntro(false);
      setConsultant((prev) => ({
        ...prev,
        intro: newIntro,
        tags: selectedFocus,
      }));
    } catch (error) {
      console.error("Error saving introduction:", error);
    }
  };
  

  const handleClose = () =>{
    setShowModal(false)
  }

// // display most recent chat message
//   const fetchActiveChatsWithLastMessage = async (consultantId) => {
//     const q = query(
//       collection(db, "chatRooms"),
//       where("consultantId", "==", consultantId) // Fetch only consultant's chats
//     );
  
//     const querySnapshot = await getDocs(q);
//     const chats = await Promise.all(
//       querySnapshot.docs.map(async (chatDoc) => {
//         const chatData = { id: chatDoc.id, ...chatDoc.data() };
  
//         // Fetch latest message from "messages" subcollection
//         const messagesQuery = query(
//           collection(db, "chatRooms", chatDoc.id, "messages"),
//           orderBy("createdAt", "desc"),
//           limit(1) // Get the most recent message
//         );
  
//         const messagesSnapshot = await getDocs(messagesQuery);
//         if (!messagesSnapshot.empty) {
//           const lastMessageDoc = messagesSnapshot.docs[0].data();
//           chatData.lastMessage = lastMessageDoc.text; // Store last message text
//         } else {
//           chatData.lastMessage = "No messages yet";
//         }
  
//         return chatData;
//       })
//     );
  
//     return chats;
//   };

const handleTakeBreak = async () => {

  try {
    const priestRef = doc(db, "priest_users", consultant?.id);
    if(consultant.mode !== 'busy'){
      await updateDoc(priestRef, { mode: "busy" });
      // console.log("Break status updated to true");
      setConsultant(prev => ({ ...prev, mode: "busy" }));
    }else{
      await updateDoc(priestRef, { mode: "online" });
      setConsultant(prev => ({ ...prev, mode: "online" }));
    }
    
  } catch (error) {
    console.error("Error updating break status:", error);
  }
};


   const radios = [
    { name: 'perMinute', value: '1' },
    { name: 'consultation', value: '2' },
  ];
  
 if (loadingauth) {
    return <div className="loading-container">
              {/* <img src="./logo.png" alt="Brand Logo" className="loading-logo" /> */}
              <Spinner animation="border" variant="success" className="loading-spinner" />
              <p className="loading-text">Thank you for bringing light to the World...</p>
           </div>; // Or a nice spinner
  }
  

    
  return consultant ? (
    <Container fluid className="py-0">
    <div className="container-fluid p-2" >
        <nav bg="dark" className="navbar navbar-expand navbar-dark" style={{"padding":"0px", margin:0}} >
            <a href="https://www.priests.africa" className="navbar-brand" style={{"color": '#CCCCCC', margin:5}} > <img src="./logo.png" width="110" alt="logo" />  </a>
            
            <div class="collapse navbar-collapse" id="toggleMobileMenu">
              <ul class="navbar-nav">
              </ul>
            </div>
            <div class="collapse navbar-collapse" id="toggleMobileMenu">
              <ul class="navbar-nav">
              </ul>
            </div>
            <div style={{align:'right'}}class="collapse navbar-collapse" id="toggleMobileMenu">
            <ul class="navbar-nav">
            <span class="navbar-text">
          
            </span> 
            
            </ul>
            <Col className="d-flex justify-content-end">
              <Button variant="light" onClick={handleWithdrawClick}>
                Earnings: <b>{consultant.credits.toFixed(2)}</b> 
                <img 
                src="/cowrieblack.png" // Update with the correct path
                alt="Feather Icon" 
                style={{ width: '20px', height: '20px'}} 
              />
              </Button>
            </Col>
            </div> 
          
            <span class="navbar-text">
            
            <div className="collapse navbar-collapse">
              <ul className="navbar-nav mr-auto">
                {/* display profile photo here */}
                <li className="nav-item">
                <a onClick={'handleShowMySub'}>
                
                </a>
                </li>
              </ul>
              
            </div>
            
            </span> 
            
        </nav>
    </div>
    <Row className="mb-3">
      <Col md={{ span: 8, offset: 2 }}>
        <Card className="shadow-sm border-0 rounded-3">
          <Card.Body className="text-center py-4">
            
            {/* Profile Image with Upload */}
            <div className="position-relative d-inline-block mb-3">
              <Image
                src={consultant.photoURL || "/default-avatar.png"}
                alt={consultant.username}
                className="rounded-circle border shadow-sm"
                style={{ width: "55px", height: "55px", objectFit: "cover" }}
              />
              {/* Hidden File Input */}
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handlePhotoChange}
                style={{ display: "none" }}
                id="upload-photo"
              />
            </div>

            {/* Welcome Message */}
            <h4 className="fw-bold mb-2">
              {consultant.username ? consultant.username : consultant.name}
            </h4>

            {/* Intro & Focus Area */}
            <p className="text-muted mb-2">
              <span className="fw-semibold text-dark"></span> {consultant?.intro || "No introduction set yet."}
            </p>
            <i className="text-muted">
              <span className="fw-semibold text-dark"></span> 
              {consultant?.tags?.length 
                ? consultant.tags.map(tag => tag.charAt(0).toUpperCase() + tag.slice(1)).join(", ")
                : "None selected."}
            </i>

            {/* charges */}

                    <div className="text-muted mt-2">
                      {/* <img src="./pay.png" width="25" alt="pay" /> My {consultant.consultationCharge > 0 ? "consultation charge" : "Charge Per Minute"}: <strong> */}
                      <img src="./pay.png" width="25" alt="pay" /> Charge Per Consultation: <strong>

                      { consultant.consultationCharge > 0 ? "  "+ consultant.consultationCharge : "  "+ consultant.ratePerMinute}
                        <img 
                          src="/cowrieblack.png" // Update with the correct path
                          alt="Feather Icon" 
                          style={{ width: '20px', height: '20px'}} 
                        />
                      </strong>
                      <p>
                      {consultant.ratePerMinute > 0 && <i> ( 
                        ${consultant.ratePerMinute * 60 + " "} 
                        per hour)</i>}

                      {consultant.consultationCharge > 0 && <i> ( 
                        ${consultant.consultationCharge + " "} 
                        per consultation)</i>}     
                      </p>
                      
                    </div>
                   

            {/* Buttons */}
            <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">
              <Button variant="outline-success" className="rounded-pill px-3" onClick={() => setEditingIntro(true)}>
                <img src="./photo2.png" width="25" alt="pay" /> Intro 
              </Button>
              <Button variant="outline-success" className="rounded-pill px-3" onClick={() => document.getElementById("upload-photo").click()}>
                <img src="./photo.png" width="25" alt="pay" /> Photo 
              </Button>
              <Button variant="outline-success" className="rounded-pill px-3" onClick={() => { setNewUsername(consultant.username || consultant.name); setShowModal(true); }}>
                <img src="./sign.png" width="25" alt="pay" /> Name 
              </Button>
              <Button style={{ borderRadius: 25 }} variant="outline-success" className="rounded-pill px-3" onClick={() => setEditRate(true)}>
                    <img src="./pay.png" width="25" alt="pay" /> Charges
              </Button>
              <Button style={{ borderRadius: 25 }} variant={consultant?.mode === "busy" ? "outline-danger" : "outline-success"} className="rounded-pill px-3" onClick={handleTakeBreak}>
                    <img src={consultant?.mode === "busy" ? "./play.png" : "./pause_green.png"} width="25" alt="break" /> {consultant?.mode === "busy" ? "Resume" : "Pause"}
              </Button>
              
            </div>

            {/* Uploading Spinner */}
            {uploading && <Spinner animation="border" size="sm" className="mt-3" />}
            
          </Card.Body>
        </Card>
      </Col>
    </Row>
    

    <p className="text-muted mb-0 mt-0 d-flex justify-content-center" style={{ fontFamily: "Inter, sans-serif", marginBottom:15, color: "grey" }}>
      Resume Chats:
   </p>
      
        <Container className="mt-2 mb-2 d-flex justify-content-center">
          <Card.Body style={{ width: '100%', maxWidth: '400px' }}>
            {activeChats.length === 0 ? (
              <Card
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "white",
                  color: "black",
                }}
              >
                <p style={{ margin: 20, color: 'grey' }}>You don't have any chats yet.</p>
              </Card>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '10px',
                  height: '70vh', // or adjust as needed
                  overflowY: 'auto',
                  paddingRight: '5px'
                }}
              >
                {[...activeChats]
                  .sort((a, b) => {
                    const aTime = a.lastMessage?.createdAt?.seconds || 0;
                    const bTime = b.lastMessage?.createdAt?.seconds || 0;
                    return bTime - aTime;
                  })
                  .map((chat) => {
                    const userLastSeen = chat.lastSeen?.[consultant.id]?.seconds || 0;
                    const hasUnseenMessage =
                      chat.lastMessage && chat.lastMessage.createdAt.seconds > userLastSeen;

                    return (
                      <Card
                        key={chat.id}
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "white",
                          color: "black",
                        }}
                        onClick={() => {
                          navigate("/activeconsultantchat", {
                            state: {
                              consultant,
                              userData: chat.user,
                              activeChat: { ...chat, chatRoomId: chat.id }
                            },
                          });

                          updateDoc(doc(db, "chatRooms", chat.id), {
                            [`lastSeen.${consultant.id}`]: serverTimestamp(),
                          });
                        }}
                      >
                        <Card.Body>
                          <div className="d-flex align-items-center">
                            <Image
                              src={chat.user?.photoURL || "https://via.placeholder.com/40"}
                              roundedCircle
                              width={40}
                              height={40}
                              className="me-3"
                            />
                            <div className="flex-grow-1">
                              <strong>{chat.user?.name || "Anonymous User"}</strong>
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="text-muted mb-0" 
                                style={{ fontSize: "1rem", 
                                flexGrow: 1,  
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "200px"  // or adjust width based on layout
                                }}
                                  title={chat.lastMessage?.text || chat.lastMessage?.type || "No messages yet"} >
                                  {chat.lastMessage?.text || chat.lastMessage?.type || "No messages yet"}...
                                </p>
                                {hasUnseenMessage && (
                                  <div className="badge bg-danger text-white ms-2" style={{ borderRadius: "1000px" }}>
                                    <img src="/mail.png" alt="New Message" width={20} height={20} />
                                  </div>
                                )}
                              </div>
                              <p className="text-muted mb-0" style={{ fontSize: "0.8rem" }}>
                                {chat.lastMessage?.createdAt?.toDate().toLocaleString() || "No Date"}
                              </p>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    );
                  })}
              </div>
            )}
          </Card.Body>
        </Container>

 

   

      {/* Modal for Editing Introduction & Focus Areas */}
      <Modal show={editingIntro} onHide={() => setEditingIntro(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Introduction & Focus Areas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label><strong>Your Introduction</strong></Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={newIntro}
              onChange={(e) => setNewIntro(e.target.value)}
              placeholder="Write a short introduction about yourself..."
            />
          </Form.Group>

          <Form.Group>
            <Form.Label><strong>Choose Your Focus Areas</strong></Form.Label>
            <div className="d-flex flex-wrap">
              {[
                "Love, Marriage & Relationship", "Business & Start-up Consultancy", "Career & Financial Readings", "General Life Readings", 
                "Future & Past Insights", "Health & Wellness", "My Spirituality", "Children & Parenting",
              ].map((tag) => (
                <Form.Check
                  key={tag}
                  type="checkbox"
                  label={tag}
                  value={tag}
                  checked={selectedFocus.includes(tag)}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedFocus((prev) =>
                      prev.includes(value) ? prev.filter((t) => t !== value) : [...prev, value]
                    );
                  }}
                  className="me-3 mb-2"
                />
              ))}
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setEditingIntro(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleSaveIntro}>Save Changes</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for Editing Rates */}
        <Modal show={editRate} onHide={() => setEditRate(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Set Your Rate</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-4">
              <Col md={{ span: 8, offset: 2 }}>
                {/* <Card className="shadow-sm p-3" style={{ borderRadius: "15px" }}>
                  <Card.Body> */}
                    {/* {editingRate ? ( */}
                      <div>
                        {/* <h5 className="mb-3">Choose & Set Your Rate</h5> */}
                        {/* <ButtonGroup  
                          className="mb-3">
                          {radios.map((radio, idx) => (
                          <ToggleButton 
                            key={idx}
                            id={`radio-${idx}`}
                            type="radio" 
                            variant={idx % 2 ? 'outline-success' : 'outline-success'}
                            name="radio"
                            value={radio.value}
                            checked={radioValue === radio.value}
                            onChange={(e) => {const value = e.currentTarget.value;
                              setRadioValue(value);
                              handleRateTypeChange(value === "1" ? "perMinute" : "consultation");
                            }}                    
                            >{radio.name}</ToggleButton>
                          ))}
                        </ButtonGroup> */}
                         
                        
                        <div className="mb-3">
                          <Form.Check 
                            type="radio"
                            id="consultation-radio"
                            name="pricing"
                            label="Per Consultation"
                            checked={rateType === "consultation"}
                            onChange={() => {
                              setRateType("consultation");
                              setRadioValue("2");
                            }}
                            className="mb-2"
                          />
                          {/* <Form.Check 
                            type="radio"
                            id="perminute-radio"
                            name="pricing"
                            label="Per Minute"
                            checked={rateType === "perMinute"}
                            onChange={() => {
                              setRateType("perMinute");
                              setRadioValue("1");
                            }}
                          /> */}
                        </div>
                        <Form.Group>
                          {rateType === "perMinute" ? (
                            <Form.Control
                              type="number"
                              value={newRate}
                              onChange={(e) => setNewRate(Number(e.target.value))}
                              placeholder="Enter per-minute rate"
                            />
                          ) : (
                            <Form.Control
                              type="number"
                              value={newConsultationCharge}
                              onChange={(e) => setNewConsultationCharge(Number(e.target.value))}
                              placeholder="Enter consultation charge"
                            />
                          )}
                        </Form.Group>
                        <div className="d-flex justify-content-start mt-1">
                      <p className="text-muted small mt-2 mb-2"> 
                          Set your rate in USD (1 Cowrie = 1 USD).
                        </p>
                        </div>
                      </div>
                
              </Col>
            </Row>
            
          </Modal.Body>
          <Modal.Footer>
              <Button variant="primary" onClick={updateRate} className="me-2">Save</Button>
                <Button variant="secondary" onClick={() => setEditRate(false)}>Cancel</Button>
          </Modal.Footer>
        </Modal>


        {/* edit username */}
        <Modal show={showModal} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Username</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Enter your new username</Form.Label>
              <Form.Control
                type="text"
                value={newUsername}
                onChange={(e) => setNewUsername(e.target.value)}
                placeholder="New username"
                autoFocus
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                handleSaveUsername(newUsername);
                handleClose();
              }}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>


          {/* withdrawal */}
        <Modal show={showATM} onHide={closeATM} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-semibold">Withdraw Earnings</Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 py-3">
          <Form.Group className="mb-3" controlId="withdrawAmount">
            <Form.Label className="fw-semibold">Amount (USD)</Form.Label>
            <Form.Control
              type="number"
              placeholder="e.g. 100"
              value={atmAmount}
              onChange={(e) => {
                setAtmAmount(e.target.value);
                setError("");
              }}
              min="0"
              step="0.01"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="accountName">
            <Form.Label className="fw-semibold">Account Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. Ojo Emeka Haruna"
              value={accountName}
              onChange={(e) => setAccountName(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="accountNumber">
            <Form.Label className="fw-semibold">Account Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. 0123456789"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-2" controlId="bankName">
            <Form.Label className="fw-semibold">Bank Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. First Bank of Nigeria"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
            />
          </Form.Group>

          {error && <div className="text-danger mt-2 fw-semibold">{error}</div>}
        </Modal.Body>


        <Modal.Footer>
          <Button variant="secondary" onClick={closeATM}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleWithdraw}>
            Confirm Withdrawal
          </Button>
        </Modal.Footer>
      </Modal>


    </Container>
  ) : null;
};

export default ConsultantDashboard;
